import { useEffect, useState } from "react"

/**
 * False during server render and the first client render, true afterwards.
 *
 * Use it to keep an entrance animation's hidden state OUT of the server-rendered
 * HTML: `initial={hydrated ? { opacity: 0, y: 24 } : false}`. Motion writes
 * `initial` straight into the SSR markup, so a hidden initial state means the
 * content ships as opacity:0 and stays invisible for anyone whose JavaScript
 * never runs — an old device, a dropped chunk, a content blocker. That is what
 * left /work blank down to the first unanimated section on an iPhone 8.
 *
 * With this, the first paint is the finished state and the animation still plays
 * on every later mount (filter changes, carousel slides, route transitions).
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => setHydrated(true), [])
  return hydrated
}
